import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toastError } from '@components/Toast';

import ListOfCostingForAccountManager from '@features/costing/components/ListOfCostingForAccountManager';
import TopFilter from '@features/costing/components/TopFilter';
import OrderTabFilters from '@features/crm/brands/components/OrderTabFilters';
import { generateOrderDashboardParams } from '@features/filter/static/filterUtil';
import OrderDashboard from '@features/order-dashboard/OrderDashboard';
import SampleTopFilter from '@features/sampleDevelopment/components/SampleTopFilter';
import AllSampleRequest from '@features/sampleDevelopment/components/AllSampleRequest';

import { setCostingFilterField } from '@store/actions/CostingAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { setSampleRequestFilterField } from '@store/actions/SampleAction';
import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

const BrandStyles = () => {
	const tabNames = {
		ORDER: 'ORDER',
		QUOTE: 'QUOTE',
		SAMPLE: 'SAMPLE'
	};
	const filterFields = useSelector((store) => store.filterFieldStore);
	const brandProfileStore = useSelector((store) => store.brandProfileStore);
	const orderDashboardStore = useSelector((store) => store.orderDashboardStore);
	const [activeTab, setActiveTab] = useState(tabNames.ORDER);
	const [orders, setOrders] = useState([]);
	const [pageNumber, setPageNumber] = useState(0);
	const dispatch = useDispatch();
	const orderRef = useRef();
	const { id } = useParams();

	useEffect(() => {
		dispatch(setCostingFilterField({ brand: { id, value: brandProfileStore.name } }));
		dispatch(setSampleRequestFilterField({ brand: { id, value: brandProfileStore.name } }));
		dispatch({
			type: Types.TOGGLE_ORDER_DASHBOARD_TABLE_GENERAL_COLUMN,
			payload: 'isFabricColumnVisible'
		});
	}, []);

	useEffect(() => {
		if (orderDashboardStore?.isSPColumnVisible) {
			dispatch({
				type: Types.TOGGLE_ORDER_DASHBOARD_TABLE_GENERAL_COLUMN,
				payload: 'isSPColumnVisible'
			});
		}
	}, [orderDashboardStore]);

	useEffect(() => {
		renderOrders();
	}, [pageNumber, filterFields]);

	const renderOrders = async () => {
		try {
			dispatch(openLoader());
			let params = `?page=${pageNumber}&size=20&sort=order.id,desc&brandIdList=${id}`;
			params += generateOrderDashboardParams(filterFields);
			const { data } = await ApiClient.GET('getOrderDashboardReports', params);
			if (data.currentPage > 0) {
				setOrders((prev) => [...prev, ...data.data]);
			} else {
				setOrders(data.data);
			}
			orderRef.current = data;
			dispatch(closeLoader());
		} catch (error) {
			toastError(error.message);
			dispatch(closeLoader());
		}
	};

	const handleOrderDashboardScroll = () => {
		const wrappedElement = document.getElementById('orderDashboardTable');
		const { scrollHeight, scrollTop, clientHeight } = wrappedElement;
		if (
			Math.abs(Math.ceil(scrollHeight - scrollTop) - clientHeight) <= 5 &&
			orderRef.current.totalElements !== orders.length
		) {
			setPageNumber((prev) => prev + 1);
		}
	};

	const renderTabContents = () => {
		if (activeTab === tabNames.ORDER) {
			return (
				<div className="style-dashboard">
					<OrderDashboard
						orderStore={orders}
						handleOrderDashboardScroll={handleOrderDashboardScroll}
						callback={() => false}
						showSummary={false}
						isShowRemarks={false}
						isShowTasks={false}
					/>
				</div>
			);
		} else if (activeTab === tabNames.QUOTE) {
			return (
				<div className="quotes-cards">
					<ListOfCostingForAccountManager requestFrom={'CRM'} />
				</div>
			);
		} else if (activeTab === tabNames.SAMPLE) {
			return (
				<div className="sample-cards">
					<AllSampleRequest requestFrom={'CRM'} />
				</div>
			);
		}
	};

	const onTabChange = (value) => {
		setActiveTab(value);
	};

	const renderFilters = () => {
		let additionalFilter = { brand: { id, value: brandProfileStore.name } };
		if (activeTab === tabNames.ORDER) {
			return <OrderTabFilters />;
		} else if (activeTab === tabNames.QUOTE) {
			return (
				<div className="quote-filter transparent-select d-flex">
					<TopFilter
						requestFrom="CRM"
						additionalData={additionalFilter}
						managerType="ACCOUNT_MANAGER"
						onSetpage={() => false}
					/>
				</div>
			);
		} else if (activeTab === tabNames.SAMPLE) {
			return (
				<div className="sample-filter transparent-select d-flex">
					<SampleTopFilter
						additionalData={additionalFilter}
						requestFrom={'CRM'}
						onSetpage={() => false}
					/>
				</div>
			);
		}
	};

	return (
		<>
			<div className="tab-contents">
				<div className="d-flex justify-content-between">
					<div className="inner-tabs">
						<ul>
							<li
								onClick={() => onTabChange(tabNames.ORDER)}
								className={activeTab === tabNames.ORDER ? 'active' : ''}
							>
								Order
							</li>
							<li
								onClick={() => onTabChange(tabNames.QUOTE)}
								className={activeTab === tabNames.QUOTE ? 'active' : ''}
							>
								Quotes
							</li>
							<li
								onClick={() => onTabChange(tabNames.SAMPLE)}
								className={activeTab === tabNames.SAMPLE ? 'active' : ''}
							>
								Sample
							</li>
						</ul>
					</div>
					{renderFilters()}
				</div>
				{renderTabContents()}
			</div>
		</>
	);
};

export default BrandStyles;
